import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const BendarrowUpRight = ({
  size,
  type,
  theme,
  className,
  dataTestId = "bendarrow-up-right",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path d="M9.529 8.862a.667.667 0 0 0 .942.943l3.334-3.334a.667.667 0 0 0 0-.942L10.47 2.195a.667.667 0 1 0-.942.943l2.195 2.195H8c-1.8 0-3.303.542-4.365 1.507C2.569 7.809 2 9.16 2 10.667v2.666a.667.667 0 1 0 1.333 0v-2.666c0-1.16.43-2.142 1.199-2.84.771-.702 1.934-1.16 3.468-1.16h3.724L9.529 8.862Z" />
  </SVGIcon>
);
